module.exports = __webpack_public_path__ + "img/menu_soup_pumpkin@3x.c9d80813.png";